import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import {
	adjustDeveloperCredits,
	deleteBillingData,
	deleteGeneratedData,
} from "../../api/commands/developer";
import { Direction } from "../../api/schemas/ledger";
import { Dialog } from "../../widgets/dialog";
import { TagInputVariant } from "../developers/model";
import { Plan } from "./generator";

export const ConfigKey = S.Literals([
	"totalRecords",
	"editsPerRecord",
	"entriesPerRecordMin",
	"entriesPerRecordMax",
	"editsPerEntryMin",
	"editsPerEntryMax",
]);

export const Message = defineMessageUnion({
	CompletedReadOptions: { enabled: S.Boolean, variant: TagInputVariant },
	ClickedDeveloperOptions: {},
	SelectedTagVariant: { variant: TagInputVariant },
	ToggledIntegrations: { enabled: S.Boolean },
	CompletedPersist: {},
	ChangedAmount: { value: S.String },
	ChangedNotes: { value: S.String },
	ClickedAdjust: { direction: Direction },
	ClickedDeleteBilling: {},
	ClickedCleanup: {},
	ClickedConfirm: {},
	GotDialogMessage: { message: Dialog.Message },
	CompletedAdjust: {
		generation: S.Number,
		result: adjustDeveloperCredits.Result,
	},
	CompletedDeleteBilling: {
		generation: S.Number,
		result: deleteBillingData.Result,
	},
	CompletedCleanup: {
		generation: S.Number,
		result: deleteGeneratedData.Result,
	},
	ChangedGenerationConfig: { key: ConfigKey, value: S.Number },
	ClickedGenerate: {},
	CompletedBuildPlan: { plan: Plan },
	ClickedCancelGeneration: {},
	CompletedBatch: { index: S.Number, generation: S.Number },
});
export type Message = typeof Message.Type;

/** The integrations flag lives on the root (KTD3). */
export const OutMessage = defineMessageUnion({
	IntegrationsToggled: { enabled: S.Boolean },
});
export type OutMessage = typeof OutMessage.Type;
